<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr-other"></i>
                新增设备表
            </div>
        </div>
        <el-form ref="form" :model="form" label-width="110px" :rules="rules">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="设备型号" prop="model">
                        <el-input v-model="form.model" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备类型" prop="type">
                        <v-select :value.sync="form.type" :id="28"></v-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="通讯模式" prop="mode">
                        <el-input v-model="form.mode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="软件版本" prop="soft_version">
                        <el-input v-model="form.soft_version" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="硬件版本" prop="hardware_version">
                        <el-input v-model="form.hardware_version" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="制造商" prop="manufacturer">
                        <el-input v-model="form.manufacturer" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="制造商地址" prop="manufacturer_add">
                        <el-input v-model="form.manufacturer_add" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="联系人" prop="contact_person">
                        <el-input v-model="form.contact_person" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-col :span="12">
                        <el-form-item label="附件上传">
                            <el-upload
                                    :on-change="changeFile"
                                    drag
                                    action="https://httpbin.org/post"
                                    multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-row>

            <div class="btn-box center">
                <div class="l-btn" @click="onSubmit">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>

        </el-form>
    </div>
</template>

<script>
    import {editDevice, getDevice} from '../../api/device'

    export default {
        data() {
            return {
                form: {
                    id: this.$route.query.id,
                    name: '',
                    model: '',
                    type: '',
                    mode: '',
                    soft_version: '',
                    hardware_version: '',
                    manufacturer: '',
                    manufacturer_add: '',
                    phone: '',
                    contact_person: ''
                },
                rules: {
                    menu_name: [{required: true, message: '请输入权限名称', trigger: 'change'}],
                    menu_type: [{required: true, message: '请选择权限类型', trigger: 'change'}],
                }
            }
        },
        created() {
            getDevice(this.$route.query.id).then(res => {
                for (let key in this.form) {
                    if (res.data[key]) {
                        this.form[key] = res.data[key]
                    }
                }
            })
        },
        methods: {
            changeFile(file, fileList) {
                log(file, fileList)
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.save()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            save() {
                let loading = this.$loading({background: 'rgba(0, 0, 0, 0.6)'})
                editDevice(this.form).then(res => {
                    // this.$message.success('保存成功')
                    this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
                    loading.close()
                    this.$router.back()
                }).catch(err => {
                    loading.close()
                })
            }
        }
    }
</script>

<style scoped>

</style>